<template>
        <div class="row">
            <div class="col-md-4">
                <div class="form-group">
                    <h5><i class="fa fa-clock-o"></i> Data limite para assinaturas 
                    <popover :title="'Data limite para assinar'" :content="'Selecionando uma data, o(s) arquivo(s) terão uma data limite para que os signatários assinem o(s) documento(s).'"></popover></h5>
                    <input v-model="request.expired_at" class="form-control" type="datetime-local">
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <h5><i class="fa fa-calendar"></i> Lembrete para assinatura
                    <popover :title="'Lembrete'" :content="'Selecionando essa opção, iremos enviar e-mail aos signatários de acordo com o período informado até que todos tenham assinado.'"></popover>
                    </h5>
                    <select v-model="request.lembrete" class="form-control">
                        <option :value="null">Nenhum</option>
                        <option :value="3">A cada 3 horas</option>
                        <option :value="6">A cada 6 horas</option>
                        <option :value="12">A cada 12 horas</option>
                        <option :value="24">A cada 24 horas</option>
                        <option :value="48">A cada 48 horas</option>
                    </select>
                </div>
            </div>
            <div class="col-md-4">
                <div class="form-group">
                    <h5><i class="fa fa-shield"></i> Somente assinaturas com certificado
                      <popover :title="'Somente certificado digital'" :content="'Marcando essa opção os signatários só poderão assinar o documento na plataforma com um certificado A1 ou A3.'"></popover></h5>
                    <select v-model="request.obrigar_certificado" class="form-control">
                        <option :value="true">Sim</option>
                        <option :value="false">Não</option>
                    </select>
                </div>
            </div>
            <div class="col-md-12">
                <div class="form-group">
                    <h5><i class="fa fa-file-text-o"></i> Mensagem Customizada  <popover :title="'Mensagem Customizada'" :content="'Digite abaixo uma mensagem para ser inserida no e-mail que será enviado aos signatários'"></popover></h5>
                    <wysiwyg :placeholder="'Digite uma mensagem'" :class="{'is-invalid': errors.has('conteudo')}"
                        v-validate="{required: true}" :name="'conteudo'" v-model="request.mensagem" />
                </div>
            </div>
        </div>
</template>
<script>
import Popover from '../Popover.vue'
    export default {
  components: { Popover },
        props: {
            request: {}
        }

    }
</script>